import { CreateSuborganizationRequestEmployeeCount, FolderType } from '@/api/generated';

export interface CreateOrganizationItemFormData {
  name: string;
  legalName?: string;
  offices?: string;
  countries?: string;
  isEnterprise?: boolean;
  keyAccountManagers?: string[];
  locales?: string[]; // FIXME: Apparently not used by UI, but is required by the backend
  jiraId?: string;
  legacyId?: string;
  pipedriveId?: string;
  employeeCount?: CreateSuborganizationRequestEmployeeCount;
  assignments?: {
    role: string;
    users: string[];
  }[];
  organization?: string;
  parent?: {
    slug: string;
    type: FolderType;
  };
}

export enum UserAccessRole {
  ADMIN = 'ADMIN',
  BASIC = 'BASIC'
}
